import { Preferences } from '@capacitor/preferences';

const SCORES_KEY = 'chompchomp_leaderboard';
const SETTINGS_KEY = 'chompchomp_settings';

export interface ScoreEntry {
  name: string;
  score: number;
  level: number;
  date: string;
}

export interface AppSettings {
  soundEnabled: boolean;
  controlType: 'dpad' | 'swipe';
  difficulty: 'easy' | 'normal' | 'hard';
}

const DEFAULT_SETTINGS: AppSettings = {
  soundEnabled: true,
  controlType: 'dpad',
  difficulty: 'normal',
};

export async function getLeaderboard(): Promise<ScoreEntry[]> {
  try {
    const { value } = await Preferences.get({ key: SCORES_KEY });
    if (value) return JSON.parse(value);
  } catch {}
  return [];
}

export async function saveScore(entry: ScoreEntry): Promise<ScoreEntry[]> {
  const scores = await getLeaderboard();
  scores.push(entry);
  scores.sort((a, b) => b.score - a.score);
  const top10 = scores.slice(0, 10);
  await Preferences.set({ key: SCORES_KEY, value: JSON.stringify(top10) });
  return top10;
}

export async function clearLeaderboard(): Promise<void> {
  await Preferences.remove({ key: SCORES_KEY });
}

export async function getSettings(): Promise<AppSettings> {
  try {
    const { value } = await Preferences.get({ key: SETTINGS_KEY });
    if (value) return { ...DEFAULT_SETTINGS, ...JSON.parse(value) };
  } catch {}
  return { ...DEFAULT_SETTINGS };
}

export async function saveSettings(settings: AppSettings): Promise<void> {
  await Preferences.set({ key: SETTINGS_KEY, value: JSON.stringify(settings) });
}
